import React, {useContext, useEffect, useMemo, useRef, useState} from 'react';

import {Card, CardContent, CardMedia, Paper, Tooltip, Avatar} from "@mui/material";

import dayjs from "dayjs";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {capitalizeFirstLetter, stringAvatar, stringToColor} from "../../Helpers/TextStyling";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import {PAContext} from "../../../Services/PAContext";
import { motion, AnimatePresence } from 'framer-motion';
import Divider from "@mui/material/Divider";
import {getAllContactsFromDatabase} from "../../Restricted/Contacts/BrowserDatabaseFunctions";




function ItineraryView(props) {

    /*
        shows all that's going on for each day of the Event
        so cycle through each day
     */

    const { PA_GlobalObject } = usePA_GlobalStore();

    const { dataArray } = useContext(PAContext);
    const { Account, SampleAttendees, authenticated  } = dataArray;

    const [dbContacts, setDbContacts] = useState([]);
    useEffect(() => {
        if (!authenticated) {
            setDbContacts([]);
            return;
        }

        let cancelled = false;

        getAllContactsFromDatabase()
            .then(contacts => {
                if (cancelled) return;
                setDbContacts(Array.isArray(contacts) ? contacts : []);
            })
            .catch(err => {
                console.error('Failed to load Contacts from browser DB:', err);
                if (!cancelled) {
                    setDbContacts([]);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [authenticated]);

    const [ attendeesReferenceArray, setAttendeesReferenceArray ] = useState( authenticated
        ? dbContacts
        : SampleAttendees);
    useEffect(() => {

        console.log("authenticated, dbContacts, SampleAttendees triggered ...");

        setAttendeesReferenceArray(
            authenticated
                ? dbContacts
                : SampleAttendees
        );
    }, [authenticated, dbContacts, SampleAttendees]);

    const [selectedAttendee, setSelectedAttendee] = useState(Account.id);
    const [sortedAttendees, setSortedAttendees] = useState([]);

    useEffect(() => {
        // 1. Identify all unique IDs involved in the Itinerary
        const allAttendeeIds = new Set(PA_GlobalObject.Planning.attendees?.map(att => att.id) || []);

        // 2. Map IDs to full Attendee objects from your reference array
        const mergedList = Array.from(allAttendeeIds).map(id => {
            return attendeesReferenceArray.find(att => att.id === id) ||
                { id, fname: "Unknown", nickname: "Unknown" };
        });

        // 3. Sort the list
        const sorted = mergedList.sort((a, b) => {
            // Current User always first
            if (a.id === Account.id) return -1;
            if (b.id === Account.id) return 1;

            const nameA = (a.nickname || a.fname || "").toLowerCase();
            const nameB = (b.nickname || b.fname || "").toLowerCase();
            return nameA.localeCompare(nameB);
        });

        setSortedAttendees(sorted);

    }, [PA_GlobalObject.Planning.attendees, attendeesReferenceArray, Account.id]);

    const [eventHasDates, setEventHasDates] = useState(PA_GlobalObject.Planning.time_table?.dates?.length > 0);
    const [eventHasDays, setEventHasDays] = useState(PA_GlobalObject.Planning.time_table?.days?.length > 0);
    const [sanitizedContent, setSanitizedContent] = useState(PA_GlobalObject.Planning.eventIntro);

    useEffect(() => {
        console.log("PA_GlobalObject.Planning.eventIntro : ", PA_GlobalObject.Planning.eventIntro);
        //if the eventIntro isn't empty
        if (PA_GlobalObject.Planning.eventIntro !== ""){
            setSanitizedContent(PA_GlobalObject.Planning.eventIntro);
        }

    }, [PA_GlobalObject.Planning.id]);

    const [selectedTimetable, setSelectedTimetable] = useState(eventHasDates || !eventHasDays ? "dates" : "days");
    const handlePromptTimetableClick = (timetable) => {
        setSelectedTimetable(timetable);
    }

    const [selectedSection, setSelectedSection] = useState("Intro");
    const handleSectionClick = (sectionName, type) => {
        setSelectedSection(sectionName);
    }

    const [sortedItems, setSortedItems] = useState([]);
    useEffect(() => {
        if (!sortedItems || sortedItems.length === 0) return;

        const firstItem = sortedItems[0];
        const isLodging = firstItem.type === "lodging";

        const begin = firstItem?.time_table?.dates?.[0]?.begin_time;
        const checkin = firstItem?.time_table?.dates?.[0]?.checkin_time;
        const checkout = firstItem?.time_table?.dates?.[firstItem.time_table.dates.length - 1]?.checkout_time;

        const firstTime = isLodging ? checkin || checkout : begin;
        const offset = (timeToOffset(firstTime) / 30) * slotHeight;

        if (scrollRef.current) {
            scrollRef.current.scrollTop = offset;
        }
    }, [sortedItems]);
    useEffect(() => {
        console.log("change the view to : "+selectedSection);
        console.log("selectedTimetable : "+selectedTimetable);

        if (selectedSection === "Intro"){




        } else {

            /*
            this is either going to look like 2024-09-25 for dates or day 2 for days
         */

            if (!usePA_GlobalStore.getState().PA_GlobalObject.Planning
                || !usePA_GlobalStore.getState().PA_GlobalObject.Planning.activities
                || !usePA_GlobalStore.getState().PA_GlobalObject.Planning.meals
                || !usePA_GlobalStore.getState().PA_GlobalObject.Planning.lodging) {
                return;
            }

            // Filter activities based on view type
            const filteredActivities = usePA_GlobalStore.getState().PA_GlobalObject.Planning.activities.filter(activity => {
                if (selectedTimetable === 'dates') {
                    // Ensure time_table.dates exists and is not an empty array
                    if (activity.time_table?.dates?.length > 0) {
                        return activity.time_table.dates[0]['date'] === selectedSection
                            || activity.time_table.dates[activity.time_table.dates.length - 1]['date'] === selectedSection;
                    }
                    return false;
                } else {
                    // Ensure time_table.days exists and is not an empty array
                    if (activity.time_table?.days?.length > 0) {
                        return Object.keys(activity.time_table.days[0]).includes(selectedSection)
                            || Object.keys(activity.time_table.days[activity.time_table.days.length - 1]).includes(selectedSection);
                    }
                    return false;
                }
            });

            // Filter meals based on view type
            const filteredMeals = usePA_GlobalStore.getState().PA_GlobalObject.Planning.meals.filter(meal => {
                if (selectedTimetable === 'dates') {
                    // Ensure time_table.dates exists and is not an empty array
                    if (meal.time_table?.dates?.length > 0) {
                        return meal.time_table.dates[0]['date'] === selectedSection;
                    }
                    return false;
                } else {
                    // Ensure time_table.days exists and is not an empty array
                    if (meal.time_table?.days?.length > 0) {
                        return Object.keys(meal.time_table.days[0]).includes(selectedSection);
                    }
                    return false;
                }
            });

            // Filter lodgings based on view type
            const filteredLodgings = usePA_GlobalStore.getState().PA_GlobalObject.Planning.lodging.filter(lodging => {
                console.log(" lodging time_table : " , lodging);

                if (selectedTimetable === 'dates') {
                    // Ensure time_table.dates exists and is not an empty array
                    if (lodging.time_table?.dates?.length > 0) {
                        return lodging.time_table.dates[0]['date'] === selectedSection
                            || lodging.time_table.dates[lodging.time_table.dates.length - 1]['date'] === selectedSection;
                    }
                    return false;
                } else {
                    // Ensure time_table.days exists and is not an empty array
                    if (lodging.time_table?.days?.length > 0) {
                        return Object.keys(lodging.time_table.days[0]).includes(selectedSection)
                            || Object.keys(lodging.time_table.days[lodging.time_table.days.length - 1]).includes(selectedSection);
                    }
                    return false;
                }
            });

            // Filter flights based on view type
            const filteredFlights = usePA_GlobalStore.getState().PA_GlobalObject.Planning.flights.filter(flight => {
                if (selectedTimetable === 'dates') {
                    // Check if the depart_timestamp matches the itineraryViewSection date
                    return dayjs(flight.depart_timestamp).isSame(dayjs(selectedSection, 'YYYY-MM-DD'), 'day');
                } else {
                    // Ensure time_table.days exists and is not an empty array
                    if (flight.time_table?.days?.length > 0) {
                        return Object.keys(flight.time_table.days[0]).includes(selectedSection)
                            || Object.keys(flight.time_table.days[flight.time_table.days.length - 1]).includes(selectedSection);
                    }
                    return false;
                }
            });

            // Combine and sort items
            const combinedItems = [
                ...filteredActivities.map(activity => ({ ...activity, type: 'activity' })),
                ...filteredMeals.map(meal => ({ ...meal, type: 'meal' })),
                ...filteredLodgings.map(lodging => ({
                    ...lodging,
                    type: 'lodging',
                    time: lodging.begin_date !== '' ?
                        dayjs(selectedSection, 'YYYY-MM-DD').isSame(dayjs(lodging.begin_date, 'MM/DD/YYYY'), 'day') ? lodging.check_in : lodging.check_out :
                        lodging.time_table.dates[0]['date'] === selectedSection ? lodging.time_table.dates[0]['checkin_time'] : lodging.time_table.dates[lodging.time_table.dates.length - 1]['checkout_time'],
                    date: lodging.begin_date !== '' ?
                        dayjs(selectedSection, 'YYYY-MM-DD').isSame(dayjs(lodging.begin_date, 'MM/DD/YYYY'), 'day') ? lodging.begin_date : lodging.end_date :
                        lodging.time_table.dates[0]['date'] === selectedSection ?
                            dayjs(lodging.time_table.dates[0]['date'] , 'YYYY-MM-DD').format('MM/DD/YYYY')
                            :
                            dayjs(lodging.time_table.dates[lodging.time_table.dates.length - 1]['date'], 'YYYY-MM-DD').format('MM/DD/YYYY')
                })),
                ...filteredFlights.map(flight => ({ ...flight, type: 'flight' })),
            ];

            console.log("combinedItems : ", combinedItems);

            const sortedItems = combinedItems.sort((a, b) => {
                const getDateTime = (item) => {

                    switch (item.type) {
                        case "activity" :
                            return dayjs(`${item['time_table'].dates[0]?.date} ${item['time_table'].dates[0]?.begin_time}`, 'YYYY-MM-DD hh:mm A');
                        case "meal" :
                            return dayjs(`${item.date} ${item.time}`, 'MM/DD/YYYY hh:mm A');
                        case "lodging" :
                            return dayjs(`${item.date} ${item.time}`, 'MM/DD/YYYY h:mm A');
                        case "flight" :
                            return dayjs(item.depart_timestamp);
                        default :
                            return dayjs();
                    }

                };

                const aTime = getDateTime(a);
                const bTime = getDateTime(b);

                return aTime.isBefore(bTime) ? -1 : 1;
            });

            console.log("sortedItems : ", sortedItems);

            setSortedItems(sortedItems);
        }

    }, [selectedSection]);

    function formatTime(time) {
        if (!time) return null;

        // Handle Day.js objects or string times
        const formattedTime = dayjs(time, ['h:mm A', 'HH:mm']).format('h:mm A');

        // Check for Noon or Midnight
        if (formattedTime === '12:00 PM') return 'Noon';
        if (formattedTime === '12:00 AM') return 'Midnight';

        return formattedTime;
    }

    const handleChipClick = ((_attendee_id) => {
        console.log("Show itinerary for : "+_attendee_id);

        setSelectedAttendee(_attendee_id);

    });


    const slotHeight = 40;

    const timeToAbsoluteMinutes = (timeStr) => {
        if (!timeStr || typeof timeStr !== "string" || !timeStr.includes(":")) return 0;
        const [time, modifier] = timeStr.split(" ");
        const [hourStr, minuteStr] = time.split(":");

        let hour = parseInt(hourStr, 10);
        const minute = parseInt(minuteStr, 10);
        if (modifier === "PM" && hour !== 12) hour += 12;
        if (modifier === "AM" && hour === 12) hour = 0;

        return hour * 60 + minute;
    };

    const generateTimeSlots = () => {
        const slots = [];
        for (let hour = 0; hour < 24; hour++) {
            const suffix = hour < 12 ? "AM" : "PM";
            const hour12 = hour % 12 === 0 ? 12 : hour % 12;

            slots.push(`${hour12}:00 ${suffix}`);
            slots.push(`${hour12}:30 ${suffix}`);
        }
        return slots;
    };

    const timeToOffset = (timeStr) => {
        return timeToAbsoluteMinutes(timeStr); // since base is now midnight (0 * 60)
    };

    const computeOverlapLevels = (items) => {
        const levels = Array(items.length).fill(0);

        const getOffsets = (item) => {
            let start = 0;
            let end = 0;

            if (item.type === 'lodging') {
                const checkin = item?.time_table?.dates?.[0]?.checkin_time;
                const checkout = item?.time_table?.dates?.[item.time_table.dates.length - 1]?.checkout_time;
                start = timeToOffset(checkin || checkout);
                end = start + 30;
            } else if (item.type === 'flight') {
                const begin = dayjs(item.depart_timestamp).format('h:mm A')
                start = timeToOffset(begin);
                const endRaw = dayjs(item.arrive_timestamp).format('h:mm A');
                end = endRaw ? timeToOffset(endRaw) : start + 30;
            } else {
                const begin = item?.time_table?.dates?.[0]?.begin_time;
                const endRaw = item?.time_table?.dates?.[0]?.end_time;

                start = timeToOffset(begin);
                end = endRaw ? timeToOffset(endRaw) : start + 30;

                // If endOffset is 0 but time is "12:00 AM", consider it as midnight of the NEXT day
                if (endRaw?.trim() === "12:00 AM") {
                    end = 1440; // full day in minutes
                }

                // Safety net: don't let end < start
                if (end < start) {
                    end = start + 30;
                }
            }

            return { start, end };
        };

        for (let i = 0; i < items.length; i++) {
            const { start: aStart, end: aEnd } = getOffsets(items[i]);

            for (let j = 0; j < i; j++) {
                const { start: bStart, end: bEnd } = getOffsets(items[j]);

                const overlaps = aStart < bEnd && aEnd > bStart;

                if (overlaps && levels[i] === levels[j]) {
                    levels[i] = levels[j] + 1;
                }
            }
        }

        console.log("levels : ", levels);
        return levels;
    };

    const computeOverlapLevelsOLD = (items) => {
        const levels = Array(items.length).fill(0);

        for (let i = 0; i < items.length; i++) {
            const itemA = items[i];
            let aStart = 0;
            let aEnd = 0;

            console.log("a type : "+ itemA.type);

            if (itemA.type === 'lodging') {
                const checkin = itemA?.time_table?.dates?.[0]?.checkin_time;
                const checkout = itemA?.time_table?.dates?.[itemA.time_table.dates.length - 1]?.checkout_time;
                aStart = timeToOffset(checkin || checkout);
                aEnd = aStart + 30
            } else {
                const aBegin = itemA?.time_table?.dates?.[0]?.begin_time;
                const aEndRaw = itemA?.time_table?.dates?.[0]?.end_time;
                aStart = timeToOffset(aBegin);
                aEnd = aEndRaw ? timeToOffset(aEndRaw) : aStart + 30;
            }

            console.log("aStart : "+ aStart + " : "+aEnd);

            for (let j = 0; j < i; j++) {
                const itemB = items[j];
                let bStart = 0;
                let bEnd = 0;

                if (itemB.type === 'lodging') {
                    const checkin = itemB?.time_table?.dates?.[0]?.checkin_time;
                    const checkout = itemB?.time_table?.dates?.[itemB.time_table.dates.length - 1]?.checkout_time;
                    bStart = timeToOffset(checkin || checkout);
                    bEnd = bStart + 30;
                } else {
                    const bBegin = itemB?.time_table?.dates?.[0]?.begin_time;
                    const bEndRaw = itemB?.time_table?.dates?.[0]?.end_time;
                    bStart = timeToOffset(bBegin);
                    bEnd = bEndRaw ? timeToOffset(bEndRaw) : bStart + 30;
                }

                console.log("bStart : "+ bStart + " : "+bEnd);

                if (aStart < bEnd && aEnd > bStart && levels[i] === levels[j]) {
                    levels[i] = levels[j] + 1;
                }
            }
        }

        console.log("levels : ", levels);

        return levels;
    };

    const overlapLevels = computeOverlapLevels(sortedItems);

    const scrollRef = useRef(null);

    const MotionSlider = ({ images }) => {
        const [current, setCurrent] = useState(0);

        useEffect(() => {
            if (images.length <= 1) return;
            const timer = setInterval(() => {
                setCurrent(prev => (prev + 1) % images.length);
            }, 4000); // 4 seconds is usually better for reading captions/eyes to adjust
            return () => clearInterval(timer);
        }, [images.length]); // Only reset timer if the count changes

        return (
            <Box sx={{ overflow: 'hidden', height: '250px', position: 'relative', borderRadius: '16px', bgcolor: '#f8f9fa' }}>
                <AnimatePresence mode="wait">
                    <motion.img
                        key={`slide-${current}`}
                        src={images[current]}
                        initial={{ opacity: 0, scale: 1.1 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.8 }}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            position: 'absolute'
                        }}
                    />
                </AnimatePresence>
            </Box>
        );
    };

    // 1. Get ALL photos marked for the album (Group View)
    const photoAlbumImages = useMemo(() => {
        return PA_GlobalObject?.Planning?.photos
            ?.filter(photo =>
                photo.photo_album &&
                (photo.attendee_id === Account.id || !photo.private)
            )
            .map(photo => {
                // 🟢 FIXED: Prioritize 'signed_url' which is what MongoDB/Zustand actually uses!
                if (photo.signed_url) return photo.signed_url;

                // Fallback to raw local data blob strings if available
                if (photo.full_data) return photo.full_data;

                // Ultimate safety return null so we can filter out un-signed images
                return null;
            })
            .filter(url => url !== null) || []; // Strip out any empty instances safely
    }, [PA_GlobalObject?.Planning?.photos, Account?.id]);

    const hasAlbum = photoAlbumImages.length > 0;

    // 2. The "Waterfall" Cover Image Selection
    const eventCover = useMemo(() => {
        const plan = PA_GlobalObject.Planning;

        // Priority 1: New coverImage object (Full Data)
        if (plan.coverImage?.full?.full_data) return plan.coverImage.full.full_data;

        // Priority 2: New coverImage object (Thumbnail Data)
        if (plan.coverImage?.thumbnail?.thumbnail_data) return plan.coverImage.thumbnail.thumbnail_data;

        // Priority 3: Legacy Full Path
        if (plan.cover_image_full_data) return plan.cover_image_full_data;

        // Priority 4: Legacy Thumbnail
        if (plan.cover_image_thumbnail) return plan.cover_image_thumbnail;

        // Priority 5: Hard Fallback
        return "https://plannedadventure.com/assets/images/user_bg1.png";
    }, [PA_GlobalObject.Planning.coverImage, PA_GlobalObject.Planning.cover_image_full_data, PA_GlobalObject.Planning.cover_image_thumbnail]);



    return (

        <div className="itinerary-list-container">
            {/* --- ITINERARY HEADER --- */}
            <Paper
                elevation={0}
                sx={{
                    p: 1.5,
                    background: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(12px)',
                    border: '1px solid rgba(255, 255, 255, 0.6)',
                    boxShadow: '0 4px 24px -6px rgba(0,0,0,0.06)',
                    borderRadius: '12px 12px 0 0',
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                    {/* Title Area */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{
                            background: 'linear-gradient(135deg, #f97316 0%, #ef4444 100%)', // Orange to Red gradient
                            p: 0.9,
                            borderRadius: '10px',
                            display: 'flex',
                            boxShadow: '0 4px 10px rgba(249, 115, 22, 0.3)'
                        }}>
                            <i className="icon-calendar" style={{ color: 'white', fontSize: '18px' }} />
                        </Box>
                        <Box sx={{ minWidth: 0 }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b', fontSize: '1rem', letterSpacing: -0.4, whiteSpace: 'nowrap' }}>
                                Itinerary
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                <i className="icon-clock" style={{ color: '#f97316', fontSize: '10px' }} />
                                <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700, fontSize: '0.65rem', letterSpacing: 0.1, whiteSpace: 'nowrap' }}>
                                    Timeline & Flow
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Controls Area */}
                    <Box sx={{
                        display: 'flex',
                        bgcolor: '#f1f5f9', // The "Track"
                        p: 0.5,
                        borderRadius: '14px',
                        border: '1px solid #e2e8f0',
                        boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.03)'
                    }}>
                        {/* 1. DATES SEGMENT */}
                        <Tooltip title="Dates View">
                            <Box
                                onClick={() => handlePromptTimetableClick('dates')}
                                sx={{
                                    width: '44px', height: '36px', borderRadius: '10px', cursor: 'pointer',
                                    bgcolor: selectedTimetable === 'dates' ? '#fff' : 'transparent',
                                    boxShadow: selectedTimetable === 'dates' ? '0 4px 12px rgba(0,0,0,0.08)' : 'none',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    transition: '0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                    position: 'relative'
                                }}
                            >
                                <i className="icon-calendar2" style={{
                                    fontSize: '18px',
                                    color: selectedTimetable === 'dates' ? '#f97316' : '#94a3b8'
                                }} />
                            </Box>
                        </Tooltip>

                        {/* 2. DAYS SEGMENT */}
                        <Tooltip title="Days View">
                            <Box
                                onClick={() => handlePromptTimetableClick('days')}
                                sx={{
                                    width: '44px', height: '36px', borderRadius: '10px', cursor: 'pointer',
                                    bgcolor: selectedTimetable === 'days' ? '#fff' : 'transparent',
                                    boxShadow: selectedTimetable === 'days' ? '0 4px 12px rgba(0,0,0,0.08)' : 'none',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    transition: '0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                    position: 'relative',
                                    mx: 0.5 // Subtle spacing between segments
                                }}
                            >
                                <i className="icon-calendar" style={{
                                    fontSize: '18px',
                                    color: selectedTimetable === 'days' ? '#f97316' : '#94a3b8'
                                }} />
                            </Box>
                        </Tooltip>

                        {/* 3. ATTENDEES SEGMENT */}
                        <Tooltip title="Attendees View">
                            <Box
                                onClick={() => handlePromptTimetableClick('attendees')}
                                sx={{
                                    width: '44px', height: '36px', borderRadius: '10px', cursor: 'pointer',
                                    bgcolor: selectedTimetable === 'attendees' ? '#fff' : 'transparent',
                                    boxShadow: selectedTimetable === 'attendees' ? '0 4px 12px rgba(0,0,0,0.08)' : 'none',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    transition: '0.2s cubic-bezier(0.4, 0, 0.2, 1)'
                                }}
                            >
                                <i className="icon-group" style={{
                                    fontSize: '18px',
                                    color: selectedTimetable === 'attendees' ? '#f97316' : '#94a3b8'
                                }} />
                            </Box>
                        </Tooltip>
                    </Box>
                </Box>
            </Paper>

            {/* show the horizontal list of Attendees, dates, or days */}
            <Box className="itinerary-list-items-container" sx={{ bgcolor: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                <Box
                    sx={{
                        display: 'flex',            // Use flexbox
                        flexDirection: 'row',       // Align children in a row
                        flexWrap: 'nowrap',         // CRITICAL: Prevents chips from jumping to the next line
                        overflow: 'auto',
                        gap: 1.5,                   // Consistent spacing between your new DateTabs
                        py: 2,                      // Padding for the "hover lift" and badges
                        px: 1,
                    }}
                >
                    {selectedTimetable === "dates" || selectedTimetable === "days" ? (
                        <>
                            {/* 1. Intro Tab (Shared by Dates & Days) */}
                            <Box
                                onClick={() => handleSectionClick("Intro")}
                                sx={{
                                    minWidth: '60px',
                                    height: '48px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    borderRadius: '12px',
                                    transition: 'all 0.2s ease',
                                    bgcolor: selectedSection === 'Intro' ? '#f97316' : '#fff',
                                    color: selectedSection === 'Intro' ? '#fff' : '#64748b',
                                    border: selectedSection === 'Intro' ? '1px solid #ea580c' : '1px solid #e2e8f0',
                                    boxShadow: selectedSection === 'Intro' ? '0 4px 12px rgba(249, 115, 22, 0.3)' : 'none',
                                    '&:hover': { transform: 'translateY(-2px)', borderColor: '#cbd5e1' }
                                }}
                            >
                                <i className="icon-home" style={{ fontSize: '14px', marginBottom: '2px' }} />
                                <Typography sx={{ fontSize: '10px', fontWeight: 900 }}>INTRO</Typography>
                            </Box>

                            {/* 2. Dynamic Timetable Rendering */}
                            {selectedTimetable === "dates" ? (
                                usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.dates
                                    ?.slice()
                                    .sort((a, b) => new Date(a.date) - new Date(b.date))
                                    .map((dateObj, index) => {
                                        const isSelected = selectedSection === dateObj.date;
                                        const dayAbbr = dayjs(dateObj.date).format('ddd').toUpperCase();
                                        const dateLabel = dayjs(dateObj.date).format('M/D');

                                        return (
                                            <Box
                                                key={`date-${index}`}
                                                onClick={() => handleSectionClick(`${dateObj.date}`, 'date')}
                                                sx={{
                                                    minWidth: '60px',
                                                    height: '48px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    cursor: 'pointer',
                                                    borderRadius: '12px',
                                                    transition: 'all 0.2s ease',
                                                    bgcolor: isSelected ? '#f97316' : '#fff',
                                                    color: isSelected ? '#fff' : '#64748b',
                                                    border: isSelected ? '1px solid #ea580c' : '1px solid #e2e8f0',
                                                    boxShadow: isSelected ? '0 4px 12px rgba(249, 115, 22, 0.3)' : 'none',
                                                    '&:hover': { transform: 'translateY(-2px)', borderColor: '#cbd5e1' }
                                                }}
                                            >
                                                <Typography sx={{ fontSize: '10px', fontWeight: 900, opacity: 0.8 }}>{dayAbbr}</Typography>
                                                <Typography sx={{ fontSize: '12px', fontWeight: 800 }}>{dateLabel}</Typography>
                                            </Box>
                                        );
                                    })
                            ) : (
                                usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.days?.map((day, index) => {
                                    const dayKey = Object.keys(day).find(k => k.startsWith('day '));
                                    const dayName = day[dayKey];
                                    const isSelected = selectedSection === capitalizeFirstLetter(dayKey);

                                    return (
                                        <Box
                                            key={`day-${index}`}
                                            onClick={() => handleSectionClick(`${capitalizeFirstLetter(dayKey)}`, 'days')}
                                            sx={{
                                                minWidth: '60px',
                                                height: '48px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer',
                                                borderRadius: '12px',
                                                transition: 'all 0.2s ease',
                                                bgcolor: isSelected ? '#f97316' : '#fff',
                                                color: isSelected ? '#fff' : '#64748b',
                                                border: isSelected ? '1px solid #ea580c' : '1px solid #e2e8f0',
                                                boxShadow: isSelected ? '0 4px 12px rgba(249, 115, 22, 0.3)' : 'none',
                                                '&:hover': { transform: 'translateY(-2px)', borderColor: '#cbd5e1' }
                                            }}
                                        >
                                            <Typography sx={{ fontSize: '10px', fontWeight: 900, opacity: 0.8 }}>
                                                {dayName.slice(0, 3).toUpperCase()}
                                            </Typography>
                                            <Typography sx={{ fontSize: '11px', fontWeight: 800 }}>
                                                {capitalizeFirstLetter(dayKey)}
                                            </Typography>
                                        </Box>
                                    );
                                })
                            )}
                        </>
                    ) : selectedTimetable === "attendees" ? (
                        sortedAttendees.map((attendee) => {
                            const attendeeAvatar = attendeesReferenceArray.find((_att) => _att.id === attendee.id);
                            const isSelected = selectedAttendee === attendee.id;
                            const fullName = attendee.nickname?.trim() || attendee.fname;

                            return (
                                <Box
                                    key={attendee.id}
                                    onClick={() => handleChipClick(attendee.id)}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        minWidth: '65px',
                                        transition: 'all 0.2s ease',
                                        transform: isSelected ? 'scale(1.05)' : 'scale(1)',
                                        '&:hover': { transform: 'translateY(-2px)' }
                                    }}
                                >
                                    {/* Avatar with selection ring */}
                                    <Box sx={{
                                        p: '3px',
                                        borderRadius: '50%',
                                        background: isSelected
                                            ? 'linear-gradient(135deg, #f97316 0%, #ef4444 100%)'
                                            : 'transparent',
                                        boxShadow: isSelected ? '0 4px 12px rgba(249, 115, 22, 0.3)' : 'none',
                                        transition: 'all 0.3s ease'
                                    }}>
                                        <Box sx={{ p: '2px', bgcolor: 'white', borderRadius: '50%', display: 'flex' }}>
                                            {!attendeeAvatar?.avatar?.preview ? (
                                                <Avatar
                                                    {...stringAvatar(fullName)}
                                                    sx={{
                                                        width: 38,
                                                        height: 38,
                                                        fontSize: '14px',
                                                        fontWeight: 700,
                                                        border: `1px solid ${stringToColor(fullName)}`
                                                    }}
                                                />
                                            ) : (
                                                <Avatar
                                                    src={attendeeAvatar.avatar.preview}
                                                    sx={{ width: 38, height: 38 }}
                                                />
                                            )}
                                        </Box>
                                    </Box>

                                    <Typography sx={{
                                        fontSize: '10px',
                                        fontWeight: isSelected ? 900 : 600,
                                        mt: 1,
                                        color: isSelected ? '#1e293b' : '#64748b',
                                        textAlign: 'center',
                                        maxWidth: '65px',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.02em'
                                    }}>
                                        {fullName}
                                    </Typography>
                                </Box>
                            );
                        })
                    ) : null}
                </Box>
            </Box>


            {/* show the list of itinerary items */}
            <div
                className={
                    props.showingPageHeader
                        ? "itinerary-section-list-items-container with-header"
                        : "itinerary-section-list-items-container"
                }
            >
                {selectedSection === "Intro" && (
                    <Card>
                        <Box sx={{
                            width: '100%',
                            mb: 3,
                            borderRadius: '24px',
                            overflow: 'hidden',
                            boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
                        }}>
                            {hasAlbum ? (
                                <MotionSlider images={photoAlbumImages}/>
                            ) : (
                                <CardMedia
                                    component="img"
                                    image={eventCover}
                                    alt={PA_GlobalObject.Planning.title || "Event Cover"}
                                    sx={{
                                        width: '100%',
                                        objectFit: 'cover',
                                        transition: 'transform 0.5s ease',
                                        '&:hover': {
                                            transform: 'scale(1.02)'
                                        }
                                    }}
                                />
                            )}
                        </Box>

                        <CardContent sx={{paddingTop: '0'}}>
                            <Box sx={{mt: 2, padding: 2}}>
                                <div dangerouslySetInnerHTML={{__html: sanitizedContent}}/>
                            </Box>
                        </CardContent>
                    </Card>
                )}
                {
                    selectedSection !== "Intro" && sortedItems.length === 0 ? (
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                py: 8,
                                px: 3,
                                mt: 2,
                                mx: 2,
                                borderRadius: '20px',
                                background: 'rgba(255, 255, 255, 0.5)',
                                border: '2px dashed #e2e8f0', // Dashed border implies "fill this space"
                                textAlign: 'center'
                            }}
                        >
                            {/* Animated/Fun Icon Container */}
                            <Box
                                sx={{
                                    width: 70,
                                    height: 70,
                                    borderRadius: '50%',
                                    background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mb: 2,
                                    boxShadow: '0 10px 20px -5px rgba(245, 158, 11, 0.2)'
                                }}
                            >
                                <i className="icon-sun" style={{ fontSize: '32px', color: '#d97706' }} />
                            </Box>

                            {/* Hero Text */}
                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 800,
                                    color: '#1e293b',
                                    mb: 0.5,
                                    letterSpacing: '-0.02em'
                                }}
                            >
                                A Blank Canvas!
                            </Typography>

                            <Typography
                                variant="body2"
                                sx={{
                                    color: '#64748b',
                                    maxWidth: '240px',
                                    lineHeight: 1.6,
                                    fontWeight: 500
                                }}
                            >
                                There are no scheduled activities for this day yet.
                                <Box component="span" sx={{ display: 'block', mt: 1, color: '#f59e0b', fontWeight: 700 }}>
                                    The day is yours to explore!
                                </Box>
                            </Typography>

                        </Box>
                    ) : (

                        selectedSection !== "Intro" ? (
                            <Box ref={scrollRef} sx={{display: "flex", overflowY: "auto"}}>
                                {/* Time Labels */}
                                <Box
                                    sx={{
                                        minWidth: 80,
                                        position: "sticky",
                                        left: 0,
                                        zIndex: 1,
                                        backgroundColor: "white",
                                        pt: 1,
                                        borderRight: "1px solid #ccc"
                                    }}
                                >
                                    {generateTimeSlots().map((slot, i) => (
                                        <Typography
                                            key={i}
                                            variant="caption"
                                            sx={{height: slotHeight, display: "flex", alignItems: "center"}}
                                        >
                                            {slot}
                                        </Typography>
                                    ))}
                                </Box>

                                {/* Itinerary Events */}
                                <Box sx={{flex: 1, position: "relative", overflowY: 'hidden'}}>

                                    {/* All-Day Items */}
                                    {sortedItems
                                        .filter(item => item['all-day'] && item?.time_table?.dates?.some(d => d.date === selectedSection))
                                        .map(item => (
                                            <Card
                                                key={`allday-${item.id}`}
                                                sx={{
                                                    position: "relative",
                                                    mb: 1,
                                                    ml: 1,
                                                    width: 220,
                                                    bgcolor: "#fff2cc",
                                                    px: 2,
                                                    py: 1,
                                                    borderRadius: "10px",
                                                    border: "2px solid white",
                                                }}
                                            >
                                                <Typography variant="body2" fontWeight="bold">
                                                    {item.title || item.name}
                                                </Typography>
                                                <Typography variant="caption">All Day</Typography>
                                            </Card>
                                        ))}

                                    {/* Timed Items */}
                                    {sortedItems
                                        .filter(item => !item['all-day']) // handle all-day separately
                                        .flatMap((item, index) => {
                                            const isActivity = item.type === "activity";
                                            const isMeal = item.type === "meal";
                                            const isLodging = item.type === "lodging";
                                            const isFlight = item.type === "flight";

                                            const dates = item?.time_table?.dates || [];

                                            // Lodging: look at the exact day
                                            const lodgingDate = dates.find(d => d.date === selectedSection);
                                            const checkin = lodgingDate?.checkin_time || null;
                                            const checkout = lodgingDate?.checkout_time || null;

                                            let begin = null;
                                            let end = null;

                                            if (isLodging) {
                                                begin = checkin || checkout;
                                                end = checkout || null;
                                            } else if (isFlight) {
                                                begin = dayjs(item.depart_timestamp).format('h:mm A');
                                                end = dayjs(item.arrive_timestamp).format('h:mm A');
                                            } else {
                                                const currentDateIndex = dates.findIndex(d => d.date === selectedSection);
                                                const current = dates[currentDateIndex];
                                                const previous = dates[currentDateIndex - 1] || {};
                                                const next = dates[currentDateIndex + 1] || {};

                                                if (isMeal || (dates.length === 1 && current)) {
                                                    begin = current?.begin_time || null;
                                                    end = current?.end_time || null;
                                                } else if (current?.begin_time && current?.end_time) {
                                                    begin = current.begin_time;
                                                    end = current.end_time;
                                                } else if (current?.begin_time && !current?.end_time && next?.end_time) {
                                                    begin = current.begin_time;
                                                    end = "11:59 PM";
                                                } else if (!current?.begin_time && current?.end_time && previous?.begin_time) {
                                                    begin = "12:00 AM";
                                                    end = current.end_time;
                                                }
                                            }

                                            if (!begin) return [];

                                            const startOffset = timeToOffset(begin);
                                            const endOffset = end
                                                ? timeToOffset(end.trim() === "12:00 AM" ? "11:59 PM" : end)
                                                : startOffset + 30;

                                            const top = (startOffset / 30) * slotHeight + 30;
                                            const rawHeight = ((endOffset - startOffset) / 30) * slotHeight;
                                            const height = isLodging ? Math.max(rawHeight, 60) : rawHeight;
                                            const overlapLevel = overlapLevels[index];
                                            const left = overlapLevel * 150;

                                            const bgColor = isMeal
                                                ? "#cbe0f7"
                                                : isLodging
                                                    ? "#fef4ec"
                                                    : isFlight
                                                        ? "#fef4ec"
                                                        : "#e8f2ed";

                                            return [{
                                                item,
                                                top,
                                                height,
                                                left,
                                                bgColor,
                                                begin,
                                                end,
                                                isActivity,
                                                isMeal,
                                                isLodging,
                                                isFlight,
                                                _lodging_time: checkin || checkout || "",
                                                checkin,
                                                checkout,
                                                overlapLevel,
                                            }];
                                        })
                                        .map(({
                                                  item,
                                                  top,
                                                  height,
                                                  left,
                                                  bgColor,
                                                  begin,
                                                  end,
                                                  isActivity,
                                                  isMeal,
                                                  isLodging,
                                                  isFlight,
                                                  _lodging_time,
                                                checkin,
                                            checkout
                                              }, index) => (
                                            <Card
                                                key={item.id}
                                                sx={{
                                                    position: "absolute",
                                                    top: `${top}px`,
                                                    left: `${left}px`,
                                                    width: 200,
                                                    height: `${height}px`,
                                                    bgcolor: bgColor,
                                                    px: 2,
                                                    py: 1,
                                                    borderRadius: "10px",
                                                    border: "2px solid white",
                                                    boxSizing: "border-box",
                                                }}
                                            >
                                                {isActivity && (
                                                    <>
                                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                            <i className="icon-list-heart" />
                                                            <Typography variant="body2" fontWeight="bold">
                                                                {item.title}
                                                            </Typography>
                                                        </Box>
                                                        <Typography variant="caption">
                                                            {begin} - {end}
                                                        </Typography>
                                                    </>
                                                )}

                                                {isMeal && (
                                                    <>
                                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                            <i className="icon-fork-knife2" />
                                                            <Typography variant="body2" fontWeight="bold">
                                                                {item.location.name || item.name}
                                                            </Typography>
                                                        </Box>
                                                        <Typography variant="caption">
                                                            {begin}{end ? ` – ${end}` : ""}
                                                        </Typography>
                                                    </>
                                                )}

                                                {isLodging && (
                                                    <>
                                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                            <i className="icon-bed" />
                                                            <Typography variant="body2" fontWeight="bold">
                                                                {item.name}
                                                            </Typography>
                                                        </Box>

                                                        {checkin && (
                                                            <Typography variant="caption">{_lodging_time} — Check-in</Typography>
                                                        )}
                                                        {checkout && (
                                                            <Typography variant="caption">{_lodging_time} — Check-out</Typography>
                                                        )}
                                                    </>
                                                )}

                                                {isFlight && (
                                                    <>
                                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                            <i className="icon-airplane" />
                                                            <Typography variant="body2" fontWeight="bold">
                                                                Depart {begin}
                                                            </Typography>
                                                        </Box>
                                                        <Typography variant="caption">{item.depart_airport_name}</Typography>
                                                        <Divider />
                                                        <Typography variant="body2">Arrive {end}</Typography>
                                                        <Typography variant="caption">{item.arrive_airport_name}</Typography>
                                                    </>
                                                )}
                                            </Card>
                                        ))}

                                </Box>
                            </Box>
                        ) : null

                    )
                }
            </div>


        </div>

    )
}

export default ItineraryView;
